export default "__VITE_ASSET__BgQUNmMJ__"